import { MAIN_TEXT_COLOR } from "shared/consts";
import styled from "styled-components";

export const Body = styled.div`
  padding-bottom: 50px;
  height: calc(100dvh - 147px);
  overflow: auto;
  box-sizing: border-box;
`

export const Empty = styled.div`
  padding: 105px 15px;
  display: flex;
  justify-content:center;align-items: center;
  color:${MAIN_TEXT_COLOR};
  font-weight: 600;
  font-size: 16px;
  line-height: 1.2;
`

export const ButtonContainer = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 0 15px 28px;
  display: flex;
  flex-direction: column;
`